import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputRadio from "../../../../components/input/input-radio.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const {
        solicitationXRayCreator,
        solicitationXRayNature,
        solicitationXRayOrganization
    } = useReportFiltersFetch({
        fetchSolicitationXRayCreator: true,
        fetchSolicitationXRayNature: true,
        fetchSolicitationXRayOrganization: true
    });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <div className="flex gap-2">
                        <InputRadio
                            name="analysis-fact"
                            id="analysis-fact"
                            label="Fato"
                            value="fact"
                            className={'w-[50%] justify-center'}
                            checked={filters.analysis === 'fact'}
                            onChange={(e) => setFilters(prev => ({...prev, analysis: e.target.value}))}
                        />

                        <InputRadio
                            name="analysis-register"
                            id="analysis-register"
                            label="Cadastro"
                            value="register"
                            className={'w-[50%]'}
                            checked={filters.analysis === 'register'}
                            onChange={(e) => setFilters(prev => ({...prev, analysis: e.target.value}))}
                        />
                    </div>

                    <div className="separator pb-2!"/>

                    <SelectComponent
                        label='Cadastrado por'
                        isMulti={true}
                        wrapValues={true}
                        options={solicitationXRayCreator}
                        value={filters.creator}
                        onChange={(value) => setFilters(prev => ({...prev, creator: value}))}
                        instanceId="creator"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={solicitationXRayNature}
                        value={filters.nature}
                        onChange={(value) => setFilters(prev => ({...prev, nature: value}))}
                        instanceId="nature"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Organização'
                        isMulti={true}
                        wrapValues={true}
                        options={solicitationXRayOrganization}
                        value={filters.organization}
                        onChange={(value) => setFilters(prev => ({...prev, organization: value}))}
                        instanceId="organization"
                        classNameWrapper={"w-full"}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;